<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-09-10 11:04:30
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <div class="pageTitle">商品调拨</div>

    <div class="btnBox">
      <el-button type="primary" @click="addrequisition()">添加调拨单</el-button>
    </div>
    <!-- addrequisition -->
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      :inline="true"
      class="mt20"
    >
      <el-form-item label="建单时间:" style="text-align: center">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="form.start_time"
            style="width: 100%;"
            clearable
          ></el-date-picker>
        </el-col>
        <el-col :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="结束时间"
            v-model="form.end_time"
            style="width: 100%;"
            clearable
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="调拨单号:">
        <el-input v-model="form.stock_out_sn" clearable></el-input>
      </el-form-item>
      <el-form-item label="调出经销商:">
        <el-col :span="12">
          <el-input v-model="form.from_sn" clearable></el-input>
        </el-col>
        <el-col :span="4" style="margin-left: 10px;">
          <el-button type="primary" @click="selectType('from')">选择</el-button>
        </el-col>
      </el-form-item>
      <el-form-item label="调入经销商:">
        <el-col :span="12">
          <el-input v-model="form.to_sn" clearable></el-input>
        </el-col>
        <el-col :span="4" style="margin-left: 10px;">
          <el-button type="primary" @click="selectType('to')">选择</el-button>
        </el-col>
      </el-form-item>

      <el-form-item label="出货状态:">
        <el-select v-model="form.status" clearable placeholder="请选择">
          <el-option key="" label="全部" value=""></el-option>
          <el-option key="0" label="未发货" value="0"></el-option>
          <el-option key="2" label="部分发货" value="2"></el-option>
          <el-option key="6" label="已完成" value="6"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="来源:">
        <el-select v-model="form.allotment_type" clearable placeholder="请选择">
          <el-option key="0" label="全部" value=""></el-option>
          <el-option key="1" label="总部" value="0"></el-option>
          <el-option key="4" label="员工" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch()" class="mr-10"
          >搜索</el-button
        >
        <el-button @click="exportData()">导出</el-button>
      </el-form-item>
    </el-form>
    <!--表格-->
    <div class="tableBox" v-loading="loading">
      <el-table
        ref="multipleTable"
        :data="tableData"
        v-loading="loading"
        height="400px"
        border
        stripe
        style="width: 100%;margin: 20px"
      >
        <el-table-column prop="stock_out_sn" label="调仓单号" fixed>
        </el-table-column>
        <el-table-column
          prop="from_name"
          label="调出经销商"
          width="250"
          fixed
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            ({{ scope.row.from_sn }}) {{ scope.row.from_name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="to_name"
          label="调入经销商"
          width="250"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            ({{ scope.row.to_sn }}) {{ scope.row.to_name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="stock_out_num"
          label="订单数量"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-button type="text" @click="detail(scope.row)">{{
              scope.row.stock_out_num
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="real_stock_out_num"
          label="已出货数量"
          show-overflow-tooltip
        >
          <template slot-scope="scope" style="padding-bottom:20px;">
            <el-button
              type="text"
              @click="Waredetail(scope.row)"
              v-if="scope.row.real_stock_out_num != 0"
              >{{ scope.row.real_stock_out_num }}</el-button
            >
            <el-button type="text" v-else>{{
              scope.row.real_stock_out_num
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="allotment_name"
          label="来源"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- {{?}} -->
            <span v-if="scope.row.allotment_type == 1"
              >总部-{{ scope.row.allotment_name }}</span
            >
            <span v-if="scope.row.allotment_type == 2"
              >经销商-{{ scope.row.allotment_name }}</span
            >

            <span v-if="scope.row.allotment_type == 3"
              >门店-{{ scope.row.allotment_name }}</span
            >
            <span v-if="scope.row.allotment_type == 4"
              >员工-{{ scope.row.allotment_name }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="建单时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="remarks" label="备注" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop=""
          label="发货状态"
          fixed="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="scope.row.status == 2">
              发货中
            </div>
            <div v-if="scope.row.status == 1">
              待收货
            </div>
            <div v-if="scope.row.status == 7">
              已取消
            </div>
            <div v-if="scope.row.status == 3">
              待付款
            </div>
            <div v-if="scope.row.status == 4">
              待审核
            </div>
            <div v-if="scope.row.status == 5">
              审核不通过
            </div>
            <div v-if="scope.row.status == 0">
              待发货
            </div>
            <div v-if="scope.row.status == 6">
              发货完成
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="操作"
          width="160"
          fixed="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="scope.row.status == 2">
              <el-button
                type="text"
                size="small"
                v-if="scope.row.transfer_status == 0"
                @click="orderStatus(scope.row, 1)"
                >启用</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="scope.row.transfer_status == 1"
                @click="orderStatus(scope.row, 0)"
                >禁用</el-button
              >

              <el-button type="text" size="small" @click="edit(scope.row)"
                >修改</el-button
              >
            </div>
            <div v-if="scope.row.status == 0">
              <el-button
                type="text"
                size="small"
                v-if="scope.row.transfer_status == 0"
                @click="orderStatus(scope.row, 1)"
                >启用</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="scope.row.transfer_status == 1"
                @click="orderStatus(scope.row, 0)"
                >禁用</el-button
              >

              <el-button type="text" size="small" @click="edit(scope.row)"
                >修改</el-button
              >

              <el-button type="text" size="small" @click="del(scope.row)"
                >删除</el-button
              >
            </div>
            <div v-if="scope.row.status == 6">
              .
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    >
    </el-pagination>

    <selectDealer
      v-if="selectDealerDialog"
      v-on:handleClose="selectDealerDialog = false"
      @pushData="getSelectinfo"
    />
    <!--批量导入-->
    <importData
      v-if="importDataDialog"
      v-on:handleClose="importDataDialog = false"
      @refresh="onSearch"
    >
    </importData>

    <el-dialog title="订单详情" :visible.sync="detailDialog" width="70%">
      <!-- <el-button @click="exportDetail">导出明细</el-button> -->

      <el-table
        ref="multipleTable"
        :data="detailData.products"
        v-loading="loading"
        border
        stripe
        style="width: 100%;margin: 20px"
      >
        <el-table-column
          prop="product_sn"
          label="商品编号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="product_name"
          label="商品名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="product_specs"
          label="规格"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="stock_out_num"
          label="订单数量"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="real_stock_out_num"
          label="已调拨数量"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialog = false">取 消</el-button>
        <el-button type="primary" @click="detailDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="调仓详情"
      :visible.sync="WaredetailDialog"
      width="70%"
      height="50%"
    >
      <div class="tableBox" v-loading="loading">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <th style="width: 80px;">调拨单号</th>
              <th style="width: 140px">调出经销商</th>
              <th style="width: 120px">调入经销商</th>
              <th style="width: 240px">物流码</th>
              <th style="width: 220px">标签类型</th>
              <th style="width: 120px">生产批次号</th>
              <th style="width: 120px">商品编号</th>
              <th style="width: 120px">商品名称</th>
              <th style="width: 120px">规格</th>
              <th style="width: 160px">调仓数量</th>
              <th style="width: 160px">操作人</th>
            </tr>
          </thead>
          <tbody>
            <!-- {{WaredetailData}} -->

            <template v-for="item in WaredetailData">
              <!-- <template v-for="(val,index) in item.products"> -->

              <tr>
                <!-- <template v-if="item.products.length > 0 && index > 0">
                                <td colspan="5"></td>
                            </template>
                            <template v-else> -->

                <td style="white-space: nowrap;">{{ item.stock_out_sn }}</td>
                <td style="white-space: nowrap;">{{ item.from_name }}</td>
                <td style="white-space: nowrap;">{{ item.to_name }}</td>
                <td style="white-space: nowrap;">{{ item.logistics_code }}</td>
                <td style="white-space: nowrap;">{{ item.code_name }}</td>
                <!-- </template> -->
                <td style="white-space: nowrap;">
                  {{ item.production_batch }}
                </td>
                <td style="white-space: nowrap;">{{ item.product_sn }}</td>
                <td style="white-space: nowrap;">{{ item.product_name }}</td>
                <td style="white-space: nowrap;">{{ item.product_specs }}</td>
                <td style="white-space: nowrap;">
                  {{ item.real_stock_in_num }}
                </td>
                <td style="white-space: nowrap;">{{ item.allotment_name }}</td>
                <!-- <td style="white-space: nowrap;">{{val.product_unit}}</td> -->
              </tr>
              <!-- </template> -->
            </template>
          </tbody>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="WaredetailDialog = false">取 消</el-button>
        <el-button type="primary" @click="WaredetailDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import selectDealer from "@/components/logistics/common/selectDealer.vue";
export default {
  name: "deliver-manage",
  data() {
    return {
      WaredetailData: [],
      detailDialog: false,
      WaredetailDialog: false,
      loading: false,
      selectDealerDialog: false,
      importDataDialog: false,
      deliverCodeDialog: false,
      form: {
        start_time: "",
        end_time: "",
        production_batch: "",
        stock_out_sn: "",
        product_sn: "",
        product_name: "",
        warehouse_sn: "",
        status: " ",
        to_sn: " ",
        to_type: "",
        isgift: "",
        from_sn: "",
        allotment_type: "",
      },
      stockArray: [], //仓库
      tableData: [],
      //分页
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
      stock_out_sn: "", //传给物流明细
      showLink: false, //'登陆地址弹窗'
      temp: "",
      detailData: {},
    };
  },
  methods: {
    // 新建商品调拨
    addrequisition() {
      this.$router.push({
        name: "addrequisition",
      });
    },
    // 启用与禁用
    orderStatus(data, temp) {
      var url = "/allocategoods/" + data.stock_out_sn;
      this.$patch("logistics", url, {
        _method: "PATCH",
        transfer_status: temp,
      })
        .then((res) => {
          this.$message({
            type: "success",
            message: "成功",
          });
          this.tableData = [];
          this.onSearch();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error.message,
          });
        });
    },
    Waredetail(data) {
      this.loading = true;

      var url = "/allocategoods/" + data.stock_out_sn + "/datas";
      this.$get("logistics", url)
        .then((res) => {
          this.WaredetailData = res.data;
          this.loading = false;
          this.WaredetailDialog = true;
        })
        .catch((error) => {
          this.loading = false;

          this.$message({
            type: "error",
            message: error.message,
          });
        });
    },

    detail(data) {
      this.loading = true;
      var url = "/allocategoods/" + data.stock_out_sn;
      this.$get("logistics", url)
        .then((res) => {
          this.detailData = res.data;
          this.loading = false;
          this.detailDialog = true;
        })
        .catch((error) => {
          this.loading = false;

          this.$message({
            type: "error",
            message: error.message,
          });
        });
    },
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    //获取仓库
    getStock() {
      this.$get("logistics", "/warehouses.all", {
        lang: "",
      })
        .then((res) => {
          this.stockArray = res.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取调出还是调入
    getSelectinfo(val) {
      if (this.temp == "to") {
        this.form.to_sn = val.dealer_sn;
        this.form.to_type = 2;
      } else {
        this.form.from_sn = val.dealer_sn;
        this.form.from_type = 2;
      }
    },
    //请求列表数据
    onSearch() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      this.loading = true;
      this.$get("logistics", "/allocategoods", {
        lang: "",
        start_time: beginstr,
        end_time: endstr,
        product_sn: this.form.product_sn,
        stock_out_sn: this.form.stock_out_sn,
        allotment_type: this.form.allotment_type,
        warehouse_sn: this.form.warehouse_sn,
        from_sn: this.form.from_sn,
        to_sn: this.form.to_sn,
        status: this.form.status,
        per_page: this.pageSize,
        page: this.pageNo,
      })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data;
          this.totalSize = res.meta.total;
        })
        .catch(function(error) {
          this.loading = false;
          console.log(error);
        });
    },
    //添加发货
    addDeliver() {
      this.$router.push({
        name: "addDeliver",
      });
    },
    //批量导入
    importData() {
      this.importDataDialog = true;
    },
    //选择经销商/门店
    selectType(flag) {
      this.temp = flag;
      this.selectDealerDialog = true;
    },
    //导出
    exportData() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");

      window.open(
        this.$Base_Export +
          "/allocategoods.export?start_time=" +
          beginstr +
          "&end_time=" +
          endstr +
          "&is_export=1" +
          "&status=" +
          this.form.status +
          "&from_sn=" +
          this.form.from_sn +
          "&to_sn=" +
          this.form.to_sn +
          "&allotment_type=" +
          this.form.allotment_type +
          "&lang=" +
          " " +
          "&stock_out_sn=" +
          this.form.stock_out_sn +
          "&signature=" +
          this.$md5(access_tokens)
      );
    },
    //发货标签码明细
    deliverDetail(row) {
      this.stock_out_sn = row.stock_out_sn;
      this.deliverCodeDialog = true;
    },
    //打印
    print(item) {
      this.$router.push({
        name: "printDeliver",
        query: {
          stock_out_sn: item.stock_out_sn,
        },
      });
    },
    //编辑
    edit(item) {
      this.$router.push({
        name: "addrequisition",
        query: {
          edit: item.stock_out_sn,
        },
      });
    },
    //删除
    del(item) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let url = "/allocategoods/" + item.stock_out_sn;
          this.$delete("logistics", url, {
            _method: "DELETE",
          })
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.onSearch();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error.message,
              });
            });
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: "已取消",
          });
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.onSearch();
    },
    // 关闭 登陆地址弹窗
    closeLink() {
      this.showLink = !this.showLink;
    },
  },
  created() {
    this.form.start_time = this.getLastMonth().last;
    this.form.end_time = this.getLastMonth().now;
    this.getStock();
    this.onSearch();
  },
  components: {
    // , importData, deliverCodeDialog
    selectDealer,
  },
};
</script>
<style lang="scss" scoped>
.tableBox {
  overflow-x: hidden;
  width: 95%;
  .table {
    // width: 300%;
  }
}
/deep/.el-table .cell.el-tooltip {
  height: 40px;
}
</style>
